module.exports = __webpack_public_path__ + "img/index17.293be213.png";